import { languages } from './src/constants/languages.mjs';
import { NS } from './src/constants/namespaces.mjs';

const supportedLocales = Object.keys(languages);
const namespaces = Object.values(NS);

const i18n = {
  defaultLocale: 'fr',
  locales: Object.entries(languages).reduce(
    (acc, [key, value]) => [
      ...new Set([...acc, ...value, key.split('-')[0]])
    ], []
  ).sort()
};

export { NS, namespaces, languages, supportedLocales };
export default i18n;
